import { useQueryClient } from "@tanstack/react-query";
import { ViaCep } from "../../../../services/ViaCep";

export const useViaCep = () => {
  const queryClient = useQueryClient();

  const buscarEndereco = (cep: string) => {
    return queryClient
      .fetchQuery({
        queryKey: ["via-cep", cep],
        queryFn: () => ViaCep.get(cep),
      })
      .then(({ data }) => data);
  };

  return { buscarEndereco };
};
